import { useState, useEffect, forwardRef } from 'react';
import { Centered, Loader } from 'components';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  url: string;
  height?: number | null;
  scrolling?: 'auto' | 'no' | 'yes';
  onLoad?: () => void;
}

const Iframe = forwardRef<HTMLIFrameElement, Props>(
  ({ url, height, scrolling = 'auto', onLoad }, ref) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      setLoading(true);
    }, [url]);

    const finishLoading = () => {
      setLoading(false);
      onLoad && onLoad();
    };

    return (
      <>
        {loading ? (
          <Centered>
            <Loader themeColor="darkBlue" />
          </Centered>
        ) : null}
        <iframe
          ref={ref}
          scrolling={scrolling}
          className={clsx({
            [classes.visuallyHidden]: loading,
          })}
          src={url}
          onLoad={finishLoading}
          width="100%"
          height={height || '100%'}
          title="frame"
          frameBorder="0"
          marginHeight={0}
          marginWidth={0}
        />
      </>
    );
  }
);

export default Iframe;
